import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ac4xz7gxe: FaireProductEntity = {
  token: "p_7ac4xz7gxe",
  type: "product",
  name: "Bianco DiNapoli 6oz Organic Paste case (12 ct)",
  brandToken: "b_67s18taze0",
  brandName: "Bianco Dinapoli",
  imageUrl:
    "https://cdn.faire.com/fastly/4c6531bbd5758f7dcc3f5e5c13139a7cbc60273dfcc87358fb4739044414d318.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4e2666b31b2b826d7b78ac1bda6bc187c108603b00edf992e447c826980114f.jpeg",
    "https://cdn.faire.com/fastly/e3ea1bb1656dee2a5fa02d295e37043b0527497bc9b254b056be4bdf9b6a8380.jpeg",
    "https://cdn.faire.com/fastly/eac2e61045d8a276056dd5de7d2edac069e1009eec285e0446b81e865c85b7ee.jpeg",
    "https://cdn.faire.com/fastly/e5bfc88294767e33e770b7363d935ed810f6ee7c6cf469bfbe90255d2c28f899.jpeg",
    "https://cdn.faire.com/fastly/1bfde35550ceb8d1ab0f53c8c6f8d4d01f317eeabf16949ecaff5cfbc7a823e9.png",
  ],
  priceDollars: 14.64,
  description:
    "Vine Ripened California organic tomatoes are washed, sorted then crushed so that the skin and seeds can be removed. Bright red tomato pulp and fresh tomato aromas are concentrated 5-fold to create a deep, rich flavor in every teaspoon.  Tomato Paste is also a valuable source of cancer fighting Lycopene! Build flavor in soups, stews, sauces, braises, roasts and more.\n\n12 cans per case, sold by case only",
  tags: [],
  msrpDollars: 29.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:10.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
